import { Instagram, Youtube, Facebook, Mail, Phone } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/brand";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="footer"
      className="bg-[#153326] text-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="inline-flex items-center gap-3 bg-[#F9F6F0]/95 backdrop-blur-sm rounded-2xl px-4 py-2.5 shadow-lg">
            <img
              src={BRAND.logoUrl}
              alt="Yogiinit"
              className="h-12 w-12 object-contain"
            />
            <span className="font-serif-display text-2xl tracking-wider text-[#1F4A38]">
              Yogiinit
            </span>
          </div>
          <p className="mt-5 font-serif-display italic text-xl text-[#EAC98A]">
            Heal. Balance. Thrive.
          </p>
          <p className="mt-4 text-sm text-[#F9F6F0]/70 leading-relaxed max-w-xs">
            A modern yoga sanctuary for calm, strength and lasting transformation.
          </p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.3em] uppercase text-[#D4A24C] mb-5">
            Quick Links
          </h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  className="text-[#F9F6F0]/80 hover:text-[#D4A24C] transition"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.3em] uppercase text-[#D4A24C] mb-5">
            Connect With Us
          </h4>
          <div className="flex gap-3 mb-6">
            <a
              href={BRAND.contact.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="h-11 w-11 rounded-full bg-white/10 hover:bg-[#D4A24C] hover:text-[#153326] flex items-center justify-center transition"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
            <a
              href={BRAND.contact.youtube}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-youtube"
              className="h-11 w-11 rounded-full bg-white/10 hover:bg-[#D4A24C] hover:text-[#153326] flex items-center justify-center transition"
              aria-label="YouTube"
            >
              <Youtube size={18} />
            </a>
            <a
              href={BRAND.contact.facebook}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook"
              className="h-11 w-11 rounded-full bg-white/10 hover:bg-[#D4A24C] hover:text-[#153326] flex items-center justify-center transition"
              aria-label="Facebook"
            >
              <Facebook size={18} />
            </a>
          </div>
          <p className="flex items-center gap-2 text-sm text-[#F9F6F0]/85 mb-2">
            <Mail size={14} className="text-[#D4A24C]" />
            <a href={`mailto:${BRAND.contact.email}`} className="hover:text-[#D4A24C] transition">
              {BRAND.contact.email}
            </a>
          </p>
          <p className="flex items-center gap-2 text-sm text-[#F9F6F0]/85">
            <Phone size={14} className="text-[#D4A24C]" />
            <a href={BRAND.contact.phoneHref} className="hover:text-[#D4A24C] transition">
              {BRAND.contact.phone}
            </a>
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#F9F6F0]/60">
          <p>© {new Date().getFullYear()} Yogiinit. All rights reserved. Founded by Nitu Yadav.</p>
          <p>Crafted with calm intention.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
